/*import React, { useState } from 'react'
import Sidebar from '../SideBar/index'
import Navbar from '../Navbar/index'
import "./Hero.css"
import BgVideo from '../../AssetsForIndex/v.mp4'

const HeroSection = () => {
     const [isOpen, setIsOpen] = useState(false)
      
     const toggle = () => {
      setIsOpen(!isOpen)
     }
  return (
    <>
      <div className='landingpage'>
        <Sidebar isOpen={isOpen} toggle={toggle}/>
        <Navbar toggle={toggle}/>
          <video src={BgVideo} autoPlay muted loop className='video-bg'>
           
          </video>
           
      </div>
    </>
  )
}

export default HeroSection*/

import React, { useState } from 'react'
import Sidebar from '../SideBar/index'
import Navbar from '../Navbar/index'
import "./Hero.css"
import BgVideo from '../../AssetsForIndex/v.mp4'

const HeroSection = () => {
   const [isOpen, setIsOpen] = useState(false)
    
   const toggle = () => {
    setIsOpen(!isOpen)
   }
  return (
    <>
    <div className='HeroContainer'>
      <Sidebar isOpen={isOpen} toggle={toggle}/>
        <Navbar toggle={toggle}/>       
          <video src={BgVideo} className='video-bg' autoPlay loop muted playsInline>
          </video>
        </div>
    </>
  )
}

export default HeroSection